import { ReactNode } from 'react';

import { TrialLoadingSpinner } from './_components/TrialLoadingSpinner';
import { useTrial } from './TrialProvider';

type Props = {
  page: ReactNode;
  paywall: ReactNode;
};

export const PremiumFeaturePage = ({ page, paywall }: Props) => {
  const { isLoading, isEligible, state } = useTrial();

  if (isLoading) {
    return <TrialLoadingSpinner />;
  }

  if (
    !isEligible || // user is not eligible for trial
    (isEligible && state !== 'pre-trial') // user chose to try out trial
  ) {
    return page;
  }

  return paywall;
};
